export const WHATSAPP_NUMBER = "5531987787330"; // +55 31 98778-7330

export const buildWhatsAppUrl = (message) => {
  const base = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}`;
  if (!message) return base;
  return `${base}&text=${encodeURIComponent(message)}`;
};

export const CLINIC = {
  name: "Visiovet Diagnóstico Veterinário",
  address: "Rua Tenente Brito Melo, 587 - Barro Preto, Belo Horizonte - MG, 30180-072",
  phoneMobile: "(31) 98778-7330",
  phoneLandline: "(31) 2511-8475",
  email: "visiovet@visiovet.com.br",
  hours: {
    weekdays: "Seg. à Sex. — 08h às 18h",
    saturday: "Sáb. — 08h às 12h",
  },
  mapEmbed: "https://www.google.com/maps?q=Rua+Tenente+Brito+Melo,+587,+Barro+Preto,+Belo+Horizonte,+MG&output=embed",
  instagram: "https://www.instagram.com/visiovetdiagnostico/",
  facebook: "https://www.facebook.com/visiovet.diagnosticoveterinario",
};

export const ASSETS = {
  facade:      "https://customer-assets.emergentagent.com/job_08a77360-e486-4a9e-80cc-d760aa777496/artifacts/cvxa9xkw_IMG_9623.JPG.webp",
  xray:        "https://customer-assets.emergentagent.com/job_08a77360-e486-4a9e-80cc-d760aa777496/artifacts/zcrwqhbr_IMG_9626.JPG.webp",
  tomograph:   "https://customer-assets.emergentagent.com/job_08a77360-e486-4a9e-80cc-d760aa777496/artifacts/wygekjnt_IMG_9627.JPG.webp",
  ultrasound:  "https://customer-assets.emergentagent.com/job_08a77360-e486-4a9e-80cc-d760aa777496/artifacts/3vo94m17_IMG_9625.JPG.webp",
  mri:         "https://customer-assets.emergentagent.com/job_08a77360-e486-4a9e-80cc-d760aa777496/artifacts/lcqjnirm_IMG_9624.JPG.webp",
  logo:        "/visiovet-logo.png",
  heroPet:     "https://images.pexels.com/photos/6235238/pexels-photo-6235238.jpeg?auto=compress&cs=tinysrgb&w=1600",
  bloodDraw:   "https://images.pexels.com/photos/6235235/pexels-photo-6235235.jpeg?auto=compress&cs=tinysrgb&w=1600",
  vetTeam:     "https://images.pexels.com/photos/6235114/pexels-photo-6235114.jpeg?auto=compress&cs=tinysrgb&w=1600",
  blogGeneric: "https://images.pexels.com/photos/5733421/pexels-photo-5733421.jpeg?auto=compress&cs=tinysrgb&w=1200",
};
